import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type {
  UserInformationBarrierSettingsLoadFulfilledAction,
  UserInformationBarrierSettingsLoadPendingAction,
  UserInformationBarrierSettingsLoadRejectedAction,
} from '../../domains/userInformationBarrierSettings/actions.types';

import type { UserInformationBarrierSettingsEntities } from './types';

const initialState: UserInformationBarrierSettingsEntities = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

export type UserInformationBarrierSettingsActions =
  | UserInformationBarrierSettingsLoadFulfilledAction
  | UserInformationBarrierSettingsLoadRejectedAction
  | UserInformationBarrierSettingsLoadPendingAction;

const reducer: Reducer<UserInformationBarrierSettingsEntities, UserInformationBarrierSettingsActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'USER_INFORMATION_BARRIER_SETTINGS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.userInformationBarrierSettings);
    case 'USER_INFORMATION_BARRIER_SETTINGS.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.id], action.payload.error);
    case 'USER_INFORMATION_BARRIER_SETTINGS.LOAD_PENDING':
      return moveToPending(state, [action.payload.id]);
    default:
      return state;
  }
};
export default reducer;
